/** @format */

const imageTypes = ['jpg', 'png', 'gif', 'jpeg', 'bmp', 'webp', 'svg', 'tiff', 'tif', 'jpeg', 'jfif', 'pjpeg', 'pjp'];

const officeTypes = ['docx', 'xlsx', 'pdf', 'pptx', 'xls'];

const filesTypes = [
	'txt',
	'md',
	'log',
	'json',
	'xml',
	'html',
	'css',
	'js',
	'java',
	'c',
	'cpp',
	'h',
	'hpp',
	'py',
	'rb',
	'go',
	'sh',
	'bat',
	'ps1',
	'psm1',
	'ps1xml',
	'psc1',
	'psd1',
	'psm1',
	'ps1xml',
	'psc1',
	'psd1',
	'ps1xml',
	'psc1',
	'ps1xml',
	'psc1',
	'psd1',
];
// 获取文件类型
export const getFileType = (fileName) => {
	if (!fileName) return 'unsupported';

	const extension = fileName.split('.').pop().toLowerCase();

	if (imageTypes.includes(extension)) return 'image';
	if (officeTypes.includes(extension)) return 'office';
	if (filesTypes.includes(extension)) return 'file';
	return 'unsupported';
};
